<template>
    <v-stepper v-model="e1" class="password-stepper create-account-stepper">
        <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" color="greenMain">
                Account Info
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="2" color="#708AA7"> Password </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card class="deposit-form create-account-form"
                    :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Account Type</legend>
                                <v-select solo :items="formatedAccountTypes" ref="accountSelect" item-value="id"
                                    item-text="account_type_display" append-icon="mdi-chevron-down"
                                    label="Select Account Type" @change="handleAccount" class="custom-select"
                                    single-line hide-details="auto"></v-select>
                            </fieldset>
                            <span v-if="error.accountTypesError" class="error-message">
                                {{ error.accountTypesError }}
                            </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Deposit</legend>
                                <v-text-field v-model="deposit" label="Write Amount Here" type="number" single-line solo
                                    hide-details class="custom-select"></v-text-field>
                            </fieldset>
                            <span v-if="error.depositError" class="error-message">
                                {{ error.depositError }}
                            </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <fieldset>
                                <legend>Currency</legend>
                                <v-text-field label="USD" single-line solo hide-details class="custom-select"
                                    disabled></v-text-field>
                            </fieldset>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                @click="handleNext">
                                Next Step
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card class="deposit-form password-field create-account-form"
                    :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                    <v-row>
                        <v-col>
                            <fieldset>
                                <legend>Password</legend>
                                <v-text-field label="**************" v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'
                                    " :type="show1 ? 'text' : 'password'" counter @click:append="show1 = !show1"
                                    single-line solo hide-details class="custom-select"></v-text-field>
                            </fieldset>
                            <div class="tick-mark justify-start">
                                <span>
                                    <v-icon small :class="hasMinimumLength
                                        ? 'text--green'
                                        : 'text--primary'
                                        ">mdi mdi-check</v-icon>8 Characters
                                </span>
                                <span>
                                    <v-icon small :class="hasLowerCase
                                        ? 'text--green'
                                        : 'text--primary'
                                        ">mdi mdi-check</v-icon>1 Lowercase
                                </span>
                                <span>
                                    <v-icon small :class="hasUpperCase
                                        ? 'text--green'
                                        : 'text--primary'
                                        ">mdi mdi-check</v-icon>1 Uppercase
                                </span>
                                <span>
                                    <v-icon small :class="hasDigit
                                        ? 'text--green'
                                        : 'text--primary'
                                        ">mdi mdi-check</v-icon>1 Digit
                                </span>
                                <span>
                                    <v-icon small :class="hasSpecialCharacter
                                        ? 'text--green'
                                        : 'text--primary'
                                        ">mdi mdi-check</v-icon>1 Special Character
                                </span>
                            </div>
                            <fieldset>
                                <legend>Confirm Password</legend>
                                <v-text-field v-model="password2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'
                                    " :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                                    label="Write Password Again" single-line solo hide-details
                                    class="custom-select"></v-text-field>
                            </fieldset>
                            <span v-if="error.passwordError" class="error-message">
                                {{ error.passwordError }}
                            </span>
                            <v-card-actions class="pa-0">
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                        @click.prevent="handlePrevious">
                                        Previous Step
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-btn class="text-capitalize btn-account" color="greenMain" tile elevation="0"
                                        :disabled="!allConditionsMet || loading" :loading="loading" @click.prevent="handleSumbit">
                                        Create Account
                                    </v-btn>
                                </v-col>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-card>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            loading: false,
            show1: false,
            show2: false,
            password: "",
            password2: "",
            e1: 1,
            selectedAccountId: null,
            deposit: null,
            error: {
                accountTypesError: null,
                depositError: null,
                passwordError: null,
            },
            hasMinimumLength: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasDigit: false,
            hasSpecialCharacter: false,
        };
    },
    computed: {
        ...mapState("trading", ["demoAccountTypes"]),

        formatedAccountTypes() {
            return (
                this.demoAccountTypes.map((item) => {
                    const { id, account_type_display } = item;
                    return { id, account_type_display };
                }) || []
            );
        },

        allConditionsMet() {
            return (
                this.hasMinimumLength &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasDigit &&
                this.hasSpecialCharacter &&
                this.password &&
                this.password2 &&
                this.password===this.password2
            );
        },
    },
    watch: {
        password: function () {
            this.hasMinimumLength = this.password?.length >= 8;
            this.hasLowerCase = /.*[a-z].*/.test(this.password);
            this.hasUpperCase = /.*[A-Z].*/.test(this.password);
            this.hasDigit = /.*\d.*/.test(this.password);
            this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(this.password);
        },
    },
    methods: {
        ...mapActions("trading", [
            TRADING__ACTIONS.DEMOACCOUNTTYPES,
            TRADING__ACTIONS.OPENNEWDEMOACCOUNT,
        ]),

        handleAccount(selectedAccount) {
            this.selectedAccountId = selectedAccount;
        },

        handleNext() {
            if (!this.selectedAccountId) {
                this.error.accountTypesError =
                    "Select at least one account type";
            } else {
                this.error.accountTypesError = null;
            }

            if (!this.deposit) {
                this.error.depositError = "Deposit field is required";
            } else if (this.deposit && this.deposit < 1) {
                this.error.depositError =
                    "Deposit must be greater than 0 and not less than 1";
            } else {
                this.error.depositError = null;
            }

            if (this.selectedAccountId && this.deposit && this.deposit >= 1) {
                this.e1 = 2;
            }
        },

        handlePrevious() {
            this.e1 = 1;
        },

        async handleSumbit() {
            this.loading = true;
            try{
                if (this.password !== this.password2) {
                this.error.passwordError = "Password did not match";
            } else {
                this.error.passwordError = null;
            }

            const data = {
                trading_account_type_id: this.selectedAccountId,
                deposit: this.deposit,
                password: this.password,
            };

            if (!Object.values(this.error).some((err) => err !== null)) {
                await this[TRADING__ACTIONS.OPENNEWDEMOACCOUNT](data);
                // this.selectedAccountId = null;
                // this.$refs.accountSelect.selectedItems = null;
                this.deposit = null;
                this.password = null;
                this.password2 = null;
            }
            }catch(error){
                toast.error(error.message || 'Failed to process withdrawal');
            }finally{
                this.loading = false;
            }
        },
    },
    async mounted() {
        await this[TRADING__ACTIONS.DEMOACCOUNTTYPES]();
    },
};
</script>
